import React from 'react';
import { Box, Grid, Stack, TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import CheckAll from "../../../../components/CheckAll";
import SortableTableHeader from "../../../../components/SortableTableHeader";
import { SortableTableHeaderPropsFactory } from "../../../../hooks/useTable";
import HelpIcon from '@mui/icons-material/Help';

const DataTableHead: React.FC<DataTableHeadProps> = props => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>
                    <CheckAll
                        onCheckAllClick={ props.onCheckAllClick }
                        onUncheckAllClick={ props.onUncheckAllClick }
                    />
                </TableCell>
                <SortableTableHeader { ...props.sortableTableHeaderPropsFactory('PHOTO_PRESENCE') }>
                    Zdjęcie
                </SortableTableHeader>
                <SortableTableHeader { ...props.sortableTableHeaderPropsFactory('ID') }>
                    ID
                </SortableTableHeader>
                <SortableTableHeader { ...props.sortableTableHeaderPropsFactory('TOWN') }>
                    Miejscowość
                </SortableTableHeader>
                <TableCell>Adres</TableCell>
                <TableCell>Drogi</TableCell>
                <SortableTableHeader { ...props.sortableTableHeaderPropsFactory('MEDIUM_KIND') }>
                    Rodzaj
                </SortableTableHeader>
                <TableCell>
                    <Grid
                        container
                        spacing={ 1 }
                        alignItems='center'
                        minWidth='340px'
                    >
                        <Grid item container xs={ 4 }>Termin</Grid>
                        <Grid item container xs={ 3.5 }>Koszt</Grid>
                        <Grid item container xs={ 3.5 }>Cena</Grid>
                    </Grid>
                </TableCell>
                <TableCell>Druk + montaż</TableCell>
                <SortableTableHeader
                    title='Oświetlenie'
                    { ...props.sortableTableHeaderPropsFactory('ILLUMINATED') }
                >
                    Ośw.
                </SortableTableHeader>
                <SortableTableHeader { ...props.sortableTableHeaderPropsFactory('FOOTFALL') }>
                    Widownia dzienna
                </SortableTableHeader>
                <TableCell>
                    <Stack flexDirection='row' alignItems='center'>
                        <Box mr='2px'>Rekomendowane</Box>
                        <Tooltip
                            title={
                                <Box p={ 1 }>
                                    Rekomendowane nośniki będą pokazywane jako pierwsze na liście
                                </Box>
                            }
                        >
                            <HelpIcon color="info" fontSize='small' sx={ { marginTop: '0 !important' } }/>
                        </Tooltip>
                    </Stack>
                </TableCell>
            </TableRow>
        </TableHead>
    );
}
export default React.memo(DataTableHead);

export interface DataTableHeadProps {
    readonly sortableTableHeaderPropsFactory: SortableTableHeaderPropsFactory;
    readonly onCheckAllClick: () => void;
    readonly onUncheckAllClick: () => void;
}